module.exports = __webpack_public_path__ + "static/media/impact-factory.4d8ec550.png";